var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashBoardAlarm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 55,
    viewBox: "0 0 49 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7883 49.3281H30.1666C30.1666 52.0926 28.127 54.857 24.4774 54.857C20.8279 54.857 18.7883 52.0926 18.7883 49.3281ZM47.9223 37.6482L44.7762 32.5452C43.5843 30.6129 42.9557 28.4013 42.9557 26.1538V18.8918C42.9557 8.99795 34.6667 0.950745 24.4803 0.950745C14.294 0.950745 6.00492 8.99795 6.00492 18.8918V26.1538C6.00492 28.4013 5.37628 30.6129 4.18441 32.5452L1.03833 37.6482C0.0768734 39.2018 0.0541514 41.0761 0.975786 42.6574C1.89742 44.2386 3.56429 45.1815 5.43316 45.1815H43.5331C45.4048 45.1815 47.0717 44.2358 47.9934 42.6574C48.9064 41.0789 48.8837 39.2046 47.9223 37.6482Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashBoardAlarm);
export default __webpack_public_path__ + "static/media/dashBoard-alarm.610a5ab5342dda518bb4b4db78e25803.svg";
export { ForwardRef as ReactComponent };